export const todayStr = (): string =>
  new Date().toISOString().split('T')[0];

export const ago30Str = (): string => {
  const d = new Date();
  d.setDate(d.getDate() - 30);
  return d.toISOString().split('T')[0];
};